import type {
  MiddlewareNextFn,
  RelayNetworkLayerResponse,
  RelayRequestAny,
  RRNLRequestError,
} from "react-relay-network-modern";

export const invalidGatewayToken =
  () => (next: MiddlewareNextFn) => async (request: RelayRequestAny) => {
    try {
      const response = await next(request);
      return response;
    } catch (error) {
      // Cspell:ignore RRNL
      const relayError = error as RRNLRequestError;
      if (
        typeof window !== "undefined" &&
        relayError.res?.text?.includes("Invalid authentication credentials")
      ) {
        window.location.href = "/404";
        return new Promise<RelayNetworkLayerResponse>(() => {});
      }
      throw error;
    }
  };
